import BccModal from 'components/Bcc/BccModal/BccModal';
import { withBccModalProps } from 'viewModel/bcc/bccModal/withBccModalProps';

export default withBccModalProps(BccModal);
